export default {
  menu: 'Start test',
  welcome: 'Welcome!',
  lead: 'You are now about to take the following test:',
  continue: 'Continue',
  introduction_1:
    'It is important that you take the test alone without help from others. Make sure that you can work without being interrupted. It is not allowed to copy and/or share any part of the test.',
  introduction_2: 'Click the Continue-button to continue.',
  introduction_3: 'I have read and accept the privacy policy and give my consent for the treatment of my personal data.',
  register: 'Register',
  first_name: 'First name',
  last_name: 'Last name',
  age: 'Age',
  application: 'Relevant position',
  gender: 'Gender'
}
